"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storageKeys = exports.enToRusKeyboardMap = exports.TRIPSTER_API_PATH = exports.SEARCH_TYPE_NAMES = exports.NUMBER_DAYS_SAVE_GEO = exports.LEFT_BORDER_CLASS = exports.LAND_PARAMS_COUNT = exports.INITIAL_VALUES_FORMIK = exports.FIELD_NAMES = exports.DEPARTURE_FOR_INIT = exports.DEFAULT_TRIPSTER_START_OPTIONS = exports.DEFAULT_TRIPSTER_FULL_OPTIONS = exports.DEFAULT_TRACKER_PARAMS = exports.DEFAULT_DEPARTURE_COUNTRY_ISO2 = void 0;

/**
 * Названия управляющих элементов сигареты
 *
 * destination - tourists - поля
 *
 * popularCountries, metaregions - "Популярные страны" и
 * "Отдых по впечатлениям" соответственно в выпадающем
 * списке destination
 *
 * submit - кнопка "Найти"
 */
var FIELD_NAMES = {
  destination: 'destination',
  datepicker: 'datepicker',
  departure: 'departure',
  tourists: 'tourists',
  popularCountries: 'popularCountries',
  metaregions: 'metaregions',
  submit: 'submit'
};
exports.FIELD_NAMES = FIELD_NAMES;
var INITIAL_VALUES_FORMIK = {
  destination: undefined,
  datepicker: undefined,
  departure: undefined,
  tourists: {
    adults: 2,
    kids: []
  }
};
exports.INITIAL_VALUES_FORMIK = INITIAL_VALUES_FORMIK;
var LEFT_BORDER_CLASS = 'cigarette__field-border';
exports.LEFT_BORDER_CLASS = LEFT_BORDER_CLASS;
var storageKeys = {
  // ключ для хранения последнего выбранного пункта в поле город вылета
  departure: 'lt-departure-city',
  // ключ для последних 3 значений сигареты, используется для предыдущих поисков
  landParams: 'lt-land-params'
};
exports.storageKeys = storageKeys;
var DEPARTURE_FOR_INIT = {
  label: 'Москва',
  value: 'Moscow',
  selectedLabel: 'Москвы'
};
exports.DEPARTURE_FOR_INIT = DEPARTURE_FOR_INIT;
var NUMBER_DAYS_SAVE_GEO = 2;
exports.NUMBER_DAYS_SAVE_GEO = NUMBER_DAYS_SAVE_GEO;
var LAND_PARAMS_COUNT = 3;
exports.LAND_PARAMS_COUNT = LAND_PARAMS_COUNT;
var SEARCH_TYPE_NAMES = {
  PACKAGE: 'package',
  HOTEL: 'hotel',
  TRIP: 'trip'
};
exports.SEARCH_TYPE_NAMES = SEARCH_TYPE_NAMES;
var DEFAULT_DEPARTURE_COUNTRY_ISO2 = 'RU';
exports.DEFAULT_DEPARTURE_COUNTRY_ISO2 = DEFAULT_DEPARTURE_COUNTRY_ISO2;
var enToRusKeyboardMap = new Map([['q', 'й'], ['w', 'ц'], ['e', 'у'], ['r', 'к'], ['t', 'е'], ['y', 'н'], ['u', 'г'], ['i', 'ш'], ['o', 'щ'], ['p', 'з'], ['[', 'х'], ['{', 'х'], [']', 'ъ'], ['}', 'ъ'], ['a', 'ф'], ['s', 'ы'], ['d', 'в'], ['f', 'а'], ['g', 'п'], ['h', 'р'], ['j', 'о'], ['k', 'л'], ['l', 'д'], [';', 'ж'], ["'", 'э'], ['"', 'э'], ['\\', 'ё'], ['|', 'ё'], ['z', 'я'], ['x', 'ч'], ['c', 'с'], ['v', 'м'], ['b', 'и'], ['n', 'т'], ['m', 'ь'], [',', 'б'], ['<', 'б'], ['.', 'ю'], ['>', 'ю']]);
exports.enToRusKeyboardMap = enToRusKeyboardMap;
var DEFAULT_TRACKER_PARAMS = {
  end_date_from: null,
  end_date_till: null
};
exports.DEFAULT_TRACKER_PARAMS = DEFAULT_TRACKER_PARAMS;
var TRIPSTER_API_PATH = 'https://experience.tripster.ru/api/partners/leveltravelapi/search/site/';
exports.TRIPSTER_API_PATH = TRIPSTER_API_PATH;
var DEFAULT_TRIPSTER_START_OPTIONS = [{
  groupName: 'popularCountries',
  options: []
}, {
  groupName: 'metaregions',
  options: []
}];
exports.DEFAULT_TRIPSTER_START_OPTIONS = DEFAULT_TRIPSTER_START_OPTIONS;
var DEFAULT_TRIPSTER_FULL_OPTIONS = [{
  groupName: 'allCountries',
  options: []
}, {
  groupName: 'allMetaregions',
  options: []
}];
exports.DEFAULT_TRIPSTER_FULL_OPTIONS = DEFAULT_TRIPSTER_FULL_OPTIONS;